export const socialMedia = [
  // {
  //   Icon: 'facebook-f',
  //   Link: 'https://github.com/mslotwinski-dev/eDirac',
  // },
  {
    Icon: 'github',
    Link: 'https://github.com/mslotwinski-dev/eDirac',
  },
  {
    Icon: 'youtube',
    Link: 'https://github.com/mslotwinski-dev/eDirac',
  },
  // {
  //   Icon: 'twitter',
  //   Link: 'https://github.com/mslotwinski-dev/eDirac',
  // },
  // {
  //   Icon: 'instagram',
  //   Link: 'https://github.com/mslotwinski-dev/eDirac',
  // },
  // {
  //   Icon: 'reddit-alien',
  //   Link: 'https://github.com/https://github.com/mslotwinski-dev/eDirac',
  // },
  // {
  //   Icon: 'discord',
  //   Link: 'https://github.com/https://github.com/mslotwinski-dev/eDirac',
  // },
  {
    Icon: 'heart',
    Collection: 'fas',
    Support: true,
    Link: 'https://github.com/mslotwinski-dev/eDirac',
  },
]
